(function () {
  "use strict";

  var body = document.body;

  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    body.classList.add("is-locked");
    var focusTarget = modal.querySelector("input:not([disabled]), button:not([disabled]), a[href]");
    if (focusTarget) window.setTimeout(function () { focusTarget.focus(); }, 20);
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    if (!document.querySelector(".overlay:not([hidden]), .mobile-drawer.is-open")) {
      body.classList.remove("is-locked");
    }
  }

  function initModals() {
    document.addEventListener("click", function (event) {
      var opener = event.target.closest("[data-modal-open]");
      var closer = event.target.closest("[data-modal-close]");

      if (opener) {
        openModal(document.getElementById(opener.getAttribute("data-modal-open")));
      }
      if (closer) {
        closeModal(closer.closest("[data-modal]"));
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      document.querySelectorAll("[data-modal]:not([hidden])").forEach(closeModal);
    });
  }

  function initMobileMenu() {
    var toggle = document.querySelector("[data-menu-toggle]");
    var drawer = document.querySelector("[data-mobile-drawer]");
    var header = document.querySelector("[data-site-header]");
    if (!toggle || !drawer) return;

    function setOpen(open) {
      if (open && header) {
        drawer.style.setProperty("--drawer-top", Math.max(0, header.getBoundingClientRect().bottom) + "px");
      }
      toggle.setAttribute("aria-expanded", String(open));
      drawer.setAttribute("aria-hidden", String(!open));
      drawer.classList.toggle("is-open", open);
      body.classList.toggle("is-locked", open);
    }

    toggle.addEventListener("click", function () {
      setOpen(!drawer.classList.contains("is-open"));
    });

    drawer.querySelectorAll("[data-menu-close], a").forEach(function (element) {
      element.addEventListener("click", function () { setOpen(false); });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && drawer.classList.contains("is-open")) setOpen(false);
    });
  }

  var revealObserver;

  function initRevealAnimations(scope) {
    var root = scope || document;
    var items = root.querySelectorAll(
      ".section-head, .card, .lookbook__item, .cat-tile, .story__media, .story__content, " +
      ".trust-item, .newsletter__inner > *, .footer__top > *, .collection-hero__top, " +
      ".product-media, .pdp__info, .delivery-timeline, .review-card, .reviews-native-cta, " +
      ".cart-assurance, .contact-detail, .contact-form-card"
    );
    if (!items.length) return;

    var reducedMotion = window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reducedMotion || !("IntersectionObserver" in window)) {
      items.forEach(function (item) {
        item.classList.add("reveal-item", "is-visible");
      });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        });
      }, {
        rootMargin: "0px 0px -8% 0px",
        threshold: .08
      });
    }

    items.forEach(function (item, index) {
      if (item.classList.contains("reveal-item")) return;
      item.classList.add("reveal-item");
      item.style.setProperty("--reveal-delay", ((index % 4) * 70) + "ms");
      revealObserver.observe(item);
    });
  }

  function initHeaderMotion() {
    var header = document.querySelector("[data-site-header]");
    if (!header) return;

    function updateHeader() {
      header.classList.toggle("is-scrolled", window.scrollY > 24);
    }

    updateHeader();
    window.addEventListener("scroll", updateHeader, { passive: true });
  }

  function initProductForms() {
    document.querySelectorAll("[data-product-root]").forEach(function (root) {
      var variantSelect = root.querySelector("[data-variant-select]");
      var optionGroups = Array.prototype.slice.call(root.querySelectorAll("[data-option-index]"));
      var addButton = root.querySelector("[data-add-to-cart]");
      var addText = root.querySelector("[data-add-to-cart-text]");
      var price = root.querySelector("[data-product-price]");
      var compare = root.querySelector("[data-product-compare]");
      var stockStatus = root.querySelector("[data-stock-status]");
      if (!variantSelect) return;

      var selectedOptions = optionGroups.map(function (group) {
        var active = group.querySelector('[data-option-value][aria-pressed="true"]');
        return active ? active.getAttribute("data-option-value") : "";
      });

      function optionData(option) {
        try {
          return JSON.parse(option.getAttribute("data-options") || "[]");
        } catch (error) {
          return [];
        }
      }

      function findVariant(values) {
        return Array.prototype.find.call(variantSelect.options, function (option) {
          var options = optionData(option);
          return options.length === values.length && options.every(function (value, index) {
            return value === values[index];
          });
        });
      }

      function updateOptionAvailability() {
        optionGroups.forEach(function (group, groupIndex) {
          group.querySelectorAll("[data-option-value]").forEach(function (button) {
            var candidate = selectedOptions.slice();
            candidate[groupIndex] = button.getAttribute("data-option-value");
            var possible = Array.prototype.some.call(variantSelect.options, function (option) {
              if (option.getAttribute("data-available") !== "true") return false;
              var values = optionData(option);
              return values.every(function (value, index) {
                return index === groupIndex ? value === candidate[index] : value === selectedOptions[index];
              });
            });
            button.classList.toggle("is-unavailable", !possible);
            button.disabled = !possible;
          });
        });
      }

      function updateStock(variant) {
        if (!stockStatus || !variant) return;
        var stockText = stockStatus.querySelector("[data-stock-text]");
        var available = variant.getAttribute("data-available") === "true";
        var managed = variant.getAttribute("data-inventory-managed") === "true";
        var policy = variant.getAttribute("data-inventory-policy") || "";
        var quantity = Number(variant.getAttribute("data-inventory-quantity") || 0);
        var threshold = Number(stockStatus.getAttribute("data-stock-threshold") || 12);
        var showExact = stockStatus.getAttribute("data-show-exact") === "true";
        var message = "Auf Lager";
        var state = "is-in-stock";

        if (!available) {
          message = "Ausverkauft";
          state = "is-out-of-stock";
        } else if (managed && quantity > 0 && showExact) {
          message = quantity + " Stück auf Lager";
          state = quantity <= threshold ? "is-low-stock" : "is-in-stock";
        } else if (managed && quantity > 0 && quantity <= threshold) {
          message = "Nur noch " + quantity + " Stück verfügbar";
          state = "is-low-stock";
        } else if (managed && quantity <= 0 && policy === "continue") {
          message = "Nachbestellung möglich";
          state = "is-preorder";
        }

        stockStatus.classList.remove("is-in-stock", "is-low-stock", "is-out-of-stock", "is-preorder");
        stockStatus.classList.add(state);
        if (stockText) stockText.textContent = message;
      }

      function updateProductMedia(variant) {
        if (!variant) return;
        var mediaId = variant.getAttribute("data-featured-media-id");
        if (!mediaId) return;

        var media = root.querySelector('[data-media-id="' + mediaId + '"]');
        if (!media || !media.parentElement) return;

        var gallery = media.parentElement;
        if (gallery.firstElementChild !== media) {
          gallery.insertBefore(media, gallery.firstElementChild);
        }

        if (typeof gallery.scrollTo === "function") {
          var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          gallery.scrollTo({ left: 0, behavior: reducedMotion ? "auto" : "smooth" });
        } else {
          gallery.scrollLeft = 0;
        }
      }

      function updateProduct() {
        var variant = findVariant(selectedOptions);
        if (!variant) {
          if (addButton) addButton.disabled = true;
          if (addText) addText.textContent = window.Solure.strings.unavailable;
          if (stockStatus) {
            stockStatus.classList.remove("is-in-stock", "is-low-stock", "is-preorder");
            stockStatus.classList.add("is-out-of-stock");
            var unavailableStockText = stockStatus.querySelector("[data-stock-text]");
            if (unavailableStockText) unavailableStockText.textContent = "Variante nicht verfügbar";
          }
          return;
        }

        variantSelect.value = variant.value;
        variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
        var available = variant.getAttribute("data-available") === "true";
        if (price) price.textContent = variant.getAttribute("data-price") || "";
        if (compare) {
          var comparePrice = variant.getAttribute("data-compare-price");
          compare.textContent = comparePrice || "";
          compare.hidden = !comparePrice;
        }
        if (addButton) addButton.disabled = !available;
        if (addText) {
          addText.textContent = available ? window.Solure.strings.addToCart : window.Solure.strings.soldOut;
        }
        updateStock(variant);
        updateProductMedia(variant);

        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.value);
        window.history.replaceState({}, "", url.toString());

        updateOptionAvailability();
      }

      optionGroups.forEach(function (group, groupIndex) {
        group.querySelectorAll("[data-option-value]").forEach(function (button) {
          button.addEventListener("click", function () {
            if (button.disabled) return;
            selectedOptions[groupIndex] = button.getAttribute("data-option-value");
            group.querySelectorAll("[data-option-value]").forEach(function (otherButton) {
              otherButton.setAttribute("aria-pressed", String(otherButton === button));
            });
            var label = group.querySelector("[data-option-selected]");
            if (label) {
              label.textContent = button.getAttribute("data-option-display") || selectedOptions[groupIndex];
            }
            updateProduct();
          });
        });
      });

      updateOptionAvailability();
      updateStock(variantSelect.options[variantSelect.selectedIndex]);
    });
  }

  function addBusinessDays(startDate, days) {
    var date = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      var weekday = date.getDay();
      if (weekday !== 0 && weekday !== 6) added += 1;
    }
    return date;
  }

  function initDeliveryTimelines(scope) {
    var root = scope || document;
    var locale = document.documentElement.lang || "de-DE";
    var formatter = new Intl.DateTimeFormat(locale, {
      weekday: "short",
      day: "2-digit",
      month: "2-digit"
    });
    var today = new Date();

    root.querySelectorAll("[data-delivery-timeline]").forEach(function (timeline) {
      if (timeline.getAttribute("data-dates-ready") === "true") return;
      timeline.setAttribute("data-dates-ready", "true");

      timeline.querySelectorAll("[data-delivery-range]").forEach(function (label) {
        var minDays = Number(label.getAttribute("data-min-days") || 0);
        var maxDays = Number(label.getAttribute("data-max-days") || minDays);
        var minDate = addBusinessDays(today, minDays);
        var maxDate = addBusinessDays(today, maxDays);

        if (minDays === 0 && maxDays === 0) {
          label.textContent = "Heute · " + formatter.format(minDate);
        } else if (minDays === maxDays) {
          label.textContent = formatter.format(minDate);
        } else {
          label.textContent = formatter.format(minDate) + " – " + formatter.format(maxDate);
        }
      });
    });
  }

  function initQuantities() {
    document.addEventListener("click", function (event) {
      var productButton = event.target.closest("[data-quantity-change]");
      if (productButton) {
        var productInput = productButton.parentElement.querySelector("[data-quantity-input]");
        if (!productInput) return;
        productInput.value = Math.max(1, Number(productInput.value || 1) + Number(productButton.getAttribute("data-quantity-change")));
      }

      var cartButton = event.target.closest("[data-cart-quantity-change]");
      if (cartButton) {
        var cartInput = cartButton.parentElement.querySelector("[data-cart-quantity-input]");
        var cartForm = document.getElementById("CartForm");
        if (!cartInput || !cartForm) return;
        cartInput.value = Math.max(0, Number(cartInput.value || 0) + Number(cartButton.getAttribute("data-cart-quantity-change")));
        window.clearTimeout(cartForm._solureSubmitTimer);
        cartForm._solureSubmitTimer = window.setTimeout(function () {
          cartForm.requestSubmit();
        }, 260);
      }
    });
  }

  function initAccordions() {
    document.querySelectorAll(".accordion__trigger").forEach(function (trigger) {
      trigger.addEventListener("click", function () {
        trigger.setAttribute("aria-expanded", String(trigger.getAttribute("aria-expanded") !== "true"));
      });
    });
  }

  function initFilters() {
    document.querySelectorAll("[data-filter-toggle]").forEach(function (toggle) {
      var panel = document.getElementById(toggle.getAttribute("aria-controls"));
      if (!panel) return;
      toggle.addEventListener("click", function () {
        var open = panel.hidden;
        panel.hidden = !open;
        toggle.setAttribute("aria-expanded", String(open));
      });
    });
  }

  function initRecommendations() {
    document.querySelectorAll("[data-product-recommendations]").forEach(function (container) {
      if (container.innerHTML.trim()) return;
      var url = container.getAttribute("data-url");
      if (!url) return;
      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var html = new DOMParser().parseFromString(text, "text/html");
          var recommendations = html.querySelector("[data-product-recommendations]");
          if (recommendations && recommendations.innerHTML.trim()) {
            container.innerHTML = recommendations.innerHTML;
            initRevealAnimations(container);
          }
        })
        .catch(function () {});
    });
  }

  function initReviewCarousels(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-review-carousel]").forEach(function (carousel) {
      if (carousel.getAttribute("data-review-ready") === "true") return;
      carousel.setAttribute("data-review-ready", "true");

      var track = carousel.querySelector("[data-review-track]");
      var previous = carousel.querySelector("[data-review-previous]");
      var next = carousel.querySelector("[data-review-next]");
      if (!track) return;

      function scrollReviews(direction) {
        var card = track.querySelector(".review-card");
        if (!card) return;
        var trackInner = track.querySelector(".reviews-carousel__track");
        var gap = trackInner ? Number.parseFloat(window.getComputedStyle(trackInner).columnGap || 0) : 0;
        if (Number.isNaN(gap)) gap = 0;
        track.scrollBy({
          left: direction * (card.getBoundingClientRect().width + gap),
          behavior: "smooth"
        });
      }

      if (previous) previous.addEventListener("click", function () { scrollReviews(-1); });
      if (next) next.addEventListener("click", function () { scrollReviews(1); });
    });
  }

  function initDynamicCheckoutLabels(scope) {
    var root = scope || document;

    function translate() {
      root.querySelectorAll(".shopify-payment-button__button--unbranded").forEach(function (button) {
        button.textContent = "Jetzt kaufen";
      });
    }

    translate();
    window.setTimeout(translate, 600);
    window.setTimeout(translate, 1600);
  }

  function initReviewSuccess(scope) {
    var root = scope || document;
    var success = root.querySelector(".review-popup .contact-form__success");
    if (!success) return;
    openModal(success.closest("[data-modal]"));
  }

  function initNewsletterPopup() {
    var popup = document.querySelector("[data-newsletter-popup]");
    if (!popup) return;
    var storageKey = popup.getAttribute("data-newsletter-key") || "solure_newsletter_seen_v26";
    try {
      if (window.sessionStorage.getItem(storageKey) === "1") return;
    } catch (error) {}

    var delay = Number(popup.getAttribute("data-newsletter-delay") || 5) * 1000;
    window.setTimeout(function showWhenClear() {
      var cookieBanner = document.querySelector("[data-cookie-banner]:not([hidden])");
      var openModalElement = document.querySelector("[data-modal]:not([hidden])");
      if (cookieBanner || openModalElement) {
        window.setTimeout(showWhenClear, 2000);
        return;
      }
      try { window.sessionStorage.setItem(storageKey, "1"); } catch (error) {}
      openModal(popup);
    }, delay);
  }

  function initCustomerPrivacy() {
    var banner = document.querySelector("[data-cookie-banner]");
    var settingsModal = document.querySelector("[data-cookie-settings]");
    if (!banner || !window.Shopify || typeof window.Shopify.loadFeatures !== "function") return;

    function privacyApi() {
      return window.Shopify && window.Shopify.customerPrivacy;
    }

    function setConsent(values, callback) {
      var api = privacyApi();
      if (!api) return;
      api.setTrackingConsent(values, function () {
        banner.hidden = true;
        closeModal(settingsModal);
        document.dispatchEvent(new CustomEvent("solure:consent-complete"));
        if (callback) callback();
      });
    }

    function syncInputs() {
      var api = privacyApi();
      if (!api || !settingsModal) return;
      var current = api.currentVisitorConsent();
      var preferences = settingsModal.querySelector("[data-cookie-preferences]");
      var analytics = settingsModal.querySelector("[data-cookie-analytics]");
      var marketing = settingsModal.querySelector("[data-cookie-marketing]");
      if (preferences) preferences.checked = current.preferences === "yes";
      if (analytics) analytics.checked = current.analytics === "yes";
      if (marketing) marketing.checked = current.marketing === "yes";
    }

    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      function (error) {
        if (error || !privacyApi()) return;
        if (privacyApi().shouldShowBanner()) banner.hidden = false;
        syncInputs();
      }
    );

    document.addEventListener("click", function (event) {
      var button = event.target.closest("[data-cookie-action], [data-cookie-open]");
      if (!button) return;
      var action = button.getAttribute("data-cookie-action");

      if (button.hasAttribute("data-cookie-open") || action === "settings") {
        syncInputs();
        openModal(settingsModal);
        return;
      }
      if (action === "accept") {
        setConsent({ preferences: true, analytics: true, marketing: true });
      }
      if (action === "decline") {
        setConsent({ preferences: false, analytics: false, marketing: false });
      }
      if (action === "save" && settingsModal) {
        setConsent({
          preferences: settingsModal.querySelector("[data-cookie-preferences]").checked,
          analytics: settingsModal.querySelector("[data-cookie-analytics]").checked,
          marketing: settingsModal.querySelector("[data-cookie-marketing]").checked
        });
      }
    });
  }

  initModals();
  initMobileMenu();
  initHeaderMotion();
  initRevealAnimations(document);
  initDeliveryTimelines(document);
  initProductForms();
  initQuantities();
  initAccordions();
  initFilters();
  initRecommendations();
  initReviewCarousels(document);
  initDynamicCheckoutLabels(document);
  initReviewSuccess(document);
  initCustomerPrivacy();
  initNewsletterPopup();

  document.addEventListener("shopify:section:load", function (event) {
    initRevealAnimations(event.target);
    initDeliveryTimelines(event.target);
    initReviewCarousels(event.target);
    initDynamicCheckoutLabels(event.target);
    initReviewSuccess(event.target);
  });
})();
